export default {
  TECH: [
    "gatsby",
    "application",
    "react",
    "html",
    "js",
    "css",
    "web",
    "development",
    "software",
    "engineering",
    "github",
    "git",
    "javascript",
    "internet",
    "document",
    "DOM",
    "document object model",
    "tech",
    "technology",
    "API",
    "platform",
    "blog",
    "coding",
    "computer",
    "nodejs",
  ],
  ABOUT: [
    "bias",
    "developer",
    "san francisco",
    "bay area",
    "software engineer",
    "walmart labs",
    "next trucking",
    "infrastructure",
    "developer productivity",
    "productivity",
    "random",
    "document",
    "contact",
    "space",
    "life",
  ],
  HOME: [
    "safe space",
    "random",
    "all things random",
    "hello there",
    "fellow human",
    "personal blog",
    "meme of the day",
    "meme",
    "reddit",
    "reddit API",
    "API",
  ],
  TWITCH: [
    "twitch",
    "wow",
    "world of warcraft",
    "overwatch",
    "warcraft 3",
    "super smash bros",
    "gaming",
    "esports",
    "streaming",
    "entertainment",
    "video games",
    "stream",
  ],
  BLOG: [
    "writing",
    "write",
    "random blog",
    "random blog posts",
    "posts",
    "tutorial",
    "helpful",
  ],
};
